import React from 'react'
import {connect} from 'react-redux'
import {fetchClient, setClientSubModule, setOpened, setOpenedSubmenu, fetchClientOptionsDict, getDsDocsToLinkWithContract, setCustomDsDocumentsModule} from 'state/actions'
import styles from './clientZoom.scss'
import ClientProfile from './clientProfile'
import ClientProfileEdit from './clientProfileEdit'
import ClientContracts from './clientContracts'
import ClientContractCreate from './clientContractCreate'
import ClientFinances from './clientFinances'
import ClientClaims from './clientClaims'
import ClientTarifications from './clientTarifications'
import Modal from 'react-modal'
import nesProp from 'nested-property'
import c from 'state/constants'

import i18n from 'lib/i18n'
const _ = i18n('clientZoom')

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
        zIndex: 2
    },
    content: {
        position: 'relative',
        top: 'initial',
        bottom: 'initial',
        left: 'initial',
        right: 'initial',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '1em',
    },
}


// This relies on object iteration being specified-order, which it normally is
const SubNav = ({currentId, items, onChange}) => (
	<div className={`${styles.headingDiv}`}>
		{Object.keys(items).map((moduleId) => (
			<div
				key={moduleId}
				className={`${styles.headingCell} info ${currentId === moduleId ? `${styles.active}` : ''}`}
				onClick={() => onChange(moduleId)}
			>
				{items[moduleId]}
			</div>
		))}
	</div>
)

@connect(state => {
	const clientId = state.app.opened
	const clientProfileForm = state.clientProfileForm
    const clientData = state.clients.clientData[clientId]
    let clientContracts = []
	const brokers = nesProp.get(state, 'office.brokers')

    if (clientData && clientData.contractIds) {
        clientContracts = clientData.contractIds.map(id => state.contracts[id])
    }
	const staffList = []
	const brokerNumbersList = []
	if (brokers) {
		for (const key in brokers) {
			if (brokers[key].brokerNumber) {
				brokerNumbersList.push(brokers[key].brokerNumber)
			}
			if (brokers[key].staff) {
				for (const oneStaffMember of brokers[key].staff) {
					if (!staffList.includes(oneStaffMember.userId)) {
						staffList.push(oneStaffMember.userId)
					}
				}
			}
		}
	}

	return ({
        subModule: state.clients.subModule,
        subModuleZoom: state.clients.subModuleZoom,
        clientId,
        clientContracts,
        data: clientData || {},
        isPhone: state.responsive.isPhone,
        clientOptionsDict: state.client.clientOptionsDict,
        clientProfileForm,
        lang: state.app.lang,
		staffList,
		brokerNumbersList,
	})
})
export default class ClientZoom extends React.Component {
	static propTypes = {
		dispatch: React.PropTypes.func.isRequired,
		subModule: React.PropTypes.string,
		subModuleZoom: React.PropTypes.object,
		clientId: React.PropTypes.string.isRequired,
		data: React.PropTypes.object,
		clientContracts: React.PropTypes.array,
        isPhone: React.PropTypes.bool,
        clientOptionsDict: React.PropTypes.object,
        lang: React.PropTypes.string
    }

    constructor(props) {
        super(props)
        this.state = {modalIsOpen: false, modalSubmoduleName: "", isSetOpenedMode: false, didDocumentsCheck: false, clientHasDocumentsToLink: []}
    }

	setSubModule(subModuleName) {
		const clientProfileStatus = this.props.clientProfileForm.formStatus.sent
        if(clientProfileStatus == false && this.props.subModule == 'edit-profile') {
            this.setSubModuleName(subModuleName)
			this.openModal()
		} else {
            const {dispatch} = this.props
            dispatch(setOpenedSubmenu())
            dispatch(setClientSubModule(subModuleName))
		}
	}

    openModal() {
        this.setState({modalIsOpen: !this.state.modalIsOpen})
    }

    setSubModuleName(submoduleName)
	{
		this.setState({modalSubmoduleName: submoduleName});
	}

	leaveModal(subModuleName)
	{
		const {dispatch} = this.props
		const { isSetOpenedMode } = this.state

		if(isSetOpenedMode == true) {
			this.props.dispatch(setOpened())
			dispatch(setClientSubModule(""))
			this.setState({isSetOpenedMode: false})
		} else {
			dispatch(setOpenedSubmenu())
			dispatch(setClientSubModule(subModuleName))

			this.setSubModuleName("")
		}

		this.openModal()
	}

	handleClose = () => {
		const clientProfileStatus = this.props.clientProfileForm.formStatus.sent
		const { isSetOpenedMode } = this.state

		if(clientProfileStatus == false && this.props.subModule == 'edit-profile') {
			this.setState({isSetOpenedMode: true})
			this.openModal()
		} else {
			this.props.dispatch(setOpened())
		}
    }

	componentDidMount() {
		const { dispatch, subModule, clientId, data, staffList, brokerNumbersList, } = this.props
		const { didDocumentsCheck } = this.state
		if (!subModule) {
			this.setSubModule('profile')
		}

		if (!data.main) {
			dispatch(fetchClient(clientId))
				.then((result) => {
					// try to define a contract for instant open in case of match
					let contractId = this.processAutoZoomArguments()

					if (contractId) {
						dispatch(setOpenedSubmenu(contractId))
					}

				})
		}

		if (!didDocumentsCheck) {
			dispatch(getDsDocsToLinkWithContract({clientId, staffList, brokerNumbersList})).then(
				res => {
					this.setState({ didDocumentsCheck: true, clientHasDocumentsToLink: res })
				}
			)
		}
	}

	/**
	 * This is used to load corect data for navigation to related client BEWB-368
	 * @param {*} prevProps
	 */
	componentDidUpdate(prevProps) {
		const {dispatch, data, clientId} = this.props

		if(clientId !== prevProps.clientId) {
			if (!data.main) {
				dispatch(fetchClient(clientId))
				.then((result)=>{
					// try to define a contract for instant open in case of match
					let contractId = this.processAutoZoomArguments()

					if (contractId) {
						dispatch(setOpenedSubmenu(contractId))
					}

				})
			}
		}
	}

	componentWillUnmount() {
		this.setSubModule('')
	}

	componentWillMount() {
        const {dispatch, clientOptionsDict} = this.props

        if (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0) {
            dispatch(fetchClientOptionsDict())
        }
    }


    /**
     * This function process the client option dic (oracle provided translations) for
     * the react select of user characteristics
     * @param {object} clientOptionsDict - oracle provided translations
     * @param {string} lang - the current language of page
     */
    handleClientOptionsDictPropChange() {
        const {clientOptionsDict, lang} = this.props
        let characteristicOptions = []

        if (clientOptionsDict && clientOptionsDict.KENMERKTYPE) {
            let charTypes = clientOptionsDict.KENMERKTYPE
            Object.keys(charTypes).map((oneCharacteristicKey)=>{
                characteristicOptions.push({
                    value: oneCharacteristicKey,
                    label: charTypes[oneCharacteristicKey][lang]
                })
            })
        }

        return characteristicOptions
    }

    /**
     * This function will process the result of search client and if there are match for contract number or
     * characteristics then return with an argument for ClientContracts to instant open that contract
     * @returns {string} contractId - the id of matched contract
     */
    processAutoZoomArguments() {
        const {subModuleZoom, clientContracts} = this.props
        let contractId = ''

        // That case when have to open the only one contract what have tha same characteristic.
        if (subModuleZoom && subModuleZoom.characteristicType && subModuleZoom.characteristicValue && clientContracts) {
            let dict = this.handleClientOptionsDictPropChange() || []
            let contractsMatched = clientContracts.filter((oneContract)=>{
                let subModuleZoomTypeWords = []
                dict.forEach((oneWord) => {
                    if(String(oneWord.value).trim().toLowerCase() == String(subModuleZoom.characteristicType).trim().toLowerCase()) {
                        subModuleZoomTypeWords.push(String(oneWord.label).trim().toLowerCase())
                    }
                })

                // if some of the comparative property is missing then skip comparison
                if (!oneContract || !oneContract.characteristicType || !oneContract.characteristicValue) {
                    return false
                }

                // check characteristics type and value are matching
                let valueCompareResult =
                    String(oneContract.characteristicValue).trim().toLowerCase() ==
                    String(subModuleZoom.characteristicValue).trim().toLowerCase()

                // trim and lowercase the characteristicType to be able compare more efficiently with the list elements
                let caseInsesitiveCharacteristicType = String(oneContract.characteristicType).trim().toLowerCase()
                // find the type in list of the types and get a boolean result
                let typeCompareResult = subModuleZoomTypeWords.indexOf(caseInsesitiveCharacteristicType) !== -1

                // if is set contractNumber for this module, then that value let only just one result
                let contractNumberCompareResult = false
                if (subModuleZoom.contractNumber) {
                    contractNumberCompareResult = String(subModuleZoom.contractNumber).trim() == String(oneContract.contractNumber).trim()
                }

                // Check if the searching by characteristics let the record in the filter
                // if no search value set, that already is ok from point of view of filter
                let isCharacteristicsOK = subModuleZoom.characteristicValue && oneContract.characteristicType && Boolean(valueCompareResult) && Boolean(typeCompareResult)
                    || (!subModuleZoom.characteristicValue && !oneContract.characteristicType)

                // Check if the searching by contractNumber let the record in the filter
                // if no search value set, that already is ok from point of view of filter
                let isContractNumberOk = (Boolean(contractNumberCompareResult) && subModuleZoom.contractNumber) || !subModuleZoom.contractNumber

                //merge the filtering results together
                // if set value compared and matter, if no value set for a filter does not matter the existence of that
                let resultOfAllMatch = isCharacteristicsOK && isContractNumberOk

                return resultOfAllMatch
            })

            // IMPORTANT, when there are more contracts matched not open anything.

            // if only one contract has match the open it
            if (contractsMatched && contractsMatched.length == 1) {
                contractId = contractsMatched[0].contractId
            }

        } else {
            // When only one contract found then no compare, open it anyway
            if (subModuleZoom && subModuleZoom.characteristicType && subModuleZoom.characteristicValue &&
                clientContracts && clientContracts.length == 1) {
                    contractId = nesProp.get(clientContracts, "0.contractId")
            }
        }

        return contractId
    }

	getIcon() {
		try {
			return require(`resources/error.svg`)
		} catch(err) {
			return require(`resources/images/icn-no-result.svg`)
		}
	}

	navigateToDocumentsList() {
		const {dispatch, clientId} = this.props
		const {clientHasDocumentsToLink} = this.state
		dispatch(setCustomDsDocumentsModule(c.DSDOCUMENTS, clientId ))
	}

	render() {
		const {subModule, subModuleZoom, data, isPhone, clientId, clientContracts} = this.props
		const {clientHasDocumentsToLink } = this.state;
		let output

		const modalIsOpen = this.state.modalIsOpen
		const modalSubmoduleName = this.state.modalSubmoduleName

		const setSubModule = (subModuleName) => {
			this.setSubModule(subModuleName)
		}

		if (!data.main) { return false }
        switch (subModule) {
			case 'profile':
				output = (
					<ClientProfile
						{...{
							clientId,
							data,
						}}
					/>
				)
				break
			case 'edit-profile':
				output = (
					<ClientProfileEdit
						{...{
							clientId,
							data,
						}}
						setSubModule={setSubModule}
					/>
				)
				break;
			case 'contracts':
				output = <ClientContracts />
				break
			case 'financial':
				output = <ClientFinances/>
				break
			case 'claims':
				output = <ClientClaims clientData={data}/>
				break
			case 'finances':
				output = <ClientFinances/>
				break
			case 'tarification':
				output = <ClientTarifications/>
				break
			default:
				output = <div>Unknown submodule!</div>
				break
		}
		return (
			<div className={styles.clientZoomContainer}>
				<div className={styles.content}>
					<div className={styles.mainTitleDiv}>
						<div className={styles.mainTitleContainer}>
							<h2 className={styles.mainTitle}>{data.main.name}</h2>
							{clientHasDocumentsToLink && clientHasDocumentsToLink.length > 0 &&
								<button type="button" className={styles.exclamationIcon} onClick={event => {
									event.preventDefault()
									this.navigateToDocumentsList()
									}}>
										<img className={styles.icon} src={this.getIcon()}/>
										<span className={styles.tooltip}>{_('toolTipForUnlinkedDocumentsWarning')}</span>
								</button>
							}
						</div>
						{!isPhone &&
							<div className={styles.moduleControls}>
								<div onClick={this.handleClose} className={styles.greyButton}>
									{_('backToList')}
								</div>
							</div>
						}
					</div>
					<div className={styles.clientZoom}>
						<div className={styles.subNav}>
							<SubNav
								currentId={subModule}
								items={{
									profile: _('profile'),
									tarification: _('tarification'),
									contracts: _('contracts'),
									financial: _('financial'),
									claims: _('claims'),
								}}
								onChange={id => this.setSubModule(id)}
							/>
						</div>
						<div className={styles.moduleWrap}>
							{output}
						</div>
					</div>
				</div>

				<Modal
					isOpen={modalIsOpen}
					style={customStyles}
					contentLabel="Modal"
				>
					<div className={styles.verifyModalContent}>
						<span className={styles.title}>{_('clientProfileLeavePopup')}</span>
						<span className={styles.message}>{_('clientProfileLeavePopupMessage')}</span>
						<div className={styles.verifyModalButtons}>
					<span
						onClick={() => this.openModal()}
						className={styles.cancel}
					>
						{_("cancel")}
					</span>
							<input
								onClick={() => this.leaveModal(modalSubmoduleName)}
								type="button"
								className={styles.greyButton + " enabled"}
								value={_("clientProfileLeaveOkButton")}
							/>
						</div>
					</div>
				</Modal>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/clients/clientZoom.jsx